import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './header.module.css';

import { EllipsisText } from '../../../helpers/ellipsistext';
import { useLead } from '../../../contexts/lead/lead.context';
import { useApp } from '../../../contexts/app/app.context';

export const HeaderComponent: React.FC = () => {
	const { applicationState } = useApp();
	const { leadProfile } = useLead();

	let fullName = '';
	if ((leadProfile.Investor.FirstName) || (leadProfile.Investor.LastName)) {
		fullName = `${leadProfile.Investor.FirstName} ${leadProfile.Investor.LastName}`;
	}

	const linkTextBranding = (
		<div className={styles.brandingText}>
			<NavLink to="/" className={styles.disabledLink} onClick={event => event.preventDefault()}>
				{applicationState.wordMark.getOrElse('')}
			</NavLink>
		</div>
	);

	return (
		<div className="">
			<div className={styles.flexItem}>
				{linkTextBranding}
				<div className={styles.welcomeText}>
					{fullName ? `Welcome, ` : ''}
					<EllipsisText text={fullName} length={28} />
				</div>
			</div>
		</div>
	);
};
